<template lang="pug">
  header.header
    template(v-if="this.windowWidth > 1240")
      router-link.logo(to="/")
        img(alt="logo" src="@/assets/img/logo.png")
      ul.header-nav
        li.header-nav__li
          router-link.header-nav__link(to="/activity") Мероприятия
        li.header-nav__li
          router-link.header-nav__link(to="/documents") Документы
        li.header-nav__li
          router-link.header-nav__link(to="/unloading") Выгрузки
        li.header-nav__li
          router-link.header-nav__link(to="/knowledge") База знаний
      .user
        .user__cash.cash-user
          .cash-user__title Баланс
          .cash-user__count
            span 345 900
            | р.
          router-link.header-nav__link(to="/withdrawal").cash-user__btn Вывести
        .user__ava
          img(src='@/assets/img/ava1.png' alt='ava')
        .user__menu.menu-user
          a(href='#' @click.prevent="dropMenu").menu-user__name Сергей Александров
            svgicon(name="arrow")
          ul.menu-user__dropdown.dropdown-menu(:class="{ active: isActive }")
            li.dropdown-menu__li
              a(href='#').dropdown-menu__link Настройки
            li.dropdown-menu__li
              a(href='#').dropdown-menu__link Профиль
            li.dropdown-menu__li
              a(href='#').dropdown-menu__link Выйти
    template(v-else)
      template(v-if="$route.meta.child")
        a(href="#" @click.prevent="$router.back()").back-page
          svgicon(name='arrow' dir="right")
      template(v-else)
        a(href="#" @click.prevent="mobileMenu = !mobileMenu").gamb
          svgicon(name='gamb')
      ul.header-nav-mobile
        li.header-nav-mobile__li
          router-link.header-nav-mobile__link(to="/activity") Мероприятия
        li.header-nav-mobile__li
          router-link.header-nav-mobile__link(to="/documents") Документы
        li.header-nav-mobile__li
          router-link.header-nav-mobile__link(to="/unloading") Выгрузки
        li.header-nav-mobile__li
          router-link.header-nav-mobile__link(to="/knowledge") База знаний
      .gamb-hidden(v-show="mobileMenu")
        a(href='#' @click.prevent="mobileMenu = !mobileMenu").gamb-close
          svgicon(name="close")
        .user
          .user__top
            .user__ava
              img(src='@/assets/img/ava1.png' alt='ava')
            .menu-user__name Сергей Александров
          .user__cash.cash-user
            .cash-user__info
              .cash-user__title Баланс
              .cash-user__count
                span 345 900
                | р.
            a(href='#').cash-user__btn Вывести
          ul.nav-mobile
            li.nav-mobile__li
              router-link.nav-mobile__link(to="/activity") Мероприятия
            li.nav-mobile__li
              router-link.nav-mobile__link(to="/documents") Документы
            li.nav-mobile__li
              router-link.nav-mobile__link(to="/unloading") Выгрузки
            li.nav-mobile__li
              router-link.nav-mobile__link(to="/knowledge") База знаний
          ul.menu-user__mobile.mobile-menu-user
            li.mobile-menu-user__li
              a(href='#').mobile-menu-user__link Настройки
            li.mobile-menu-user__li
              a(href='#').mobile-menu-user__link Профиль
            li.mobile-menu-user__li
              a(href='#').mobile-menu-user__link Выйти

</template>

<script>
  export default {
    name: 'Header',
    data: function() {
      return {
        windowWidth: null,
        isActive: false,
        mobileMenu: false,
      }
    },
    watch: {
      $route() {
        this.mobileMenu = false;
      }
    },
    mounted() {
      var vm = this;
      document.addEventListener('click', function () {
        const el = event.target.className;
        if(el != 'menu-user__name') {
          vm.isActive = false;
        }
      });
      this.$nextTick(function() {
        window.addEventListener('resize', this.resize);
        //Init
        this.resize()
      })
    },
    methods: {
      dropMenu() {
        return this.isActive = !this.isActive;
      },
      resize() {
        this.windowWidth = document.documentElement.clientWidth;
      },
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    }
  }
</script>

<style lang="scss">
.header{
  display: flex;
  align-items: center;
  padding: 13px 40px 13px;
  box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  background-color: #f4f5f6;
  position: relative;
  &-nav{
    display: flex;
    padding: 0;
    margin: 0;
    &__li{
      display: block;
      margin-right: 25px;
    }
    &__link{
      color: #161616;
      font-family: "Open Sans";
      font-size: 16px;
      font-weight: 400;
      line-height: 25px;
      text-decoration: none;
      &.router-link-active{
        font-weight: bold;
      }
    }
  }
}
.logo{
  width: 55px;
  height: 55px;
  margin-right: 40px;
  img{
    display: block;
    width: 100%;
  }
}
.user{
  margin-left: auto;
  display: flex;
  align-items: center;
  &__ava{
    margin-right: 20px;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.cash-user{
  display: flex;
  align-items: center;
  margin-right: 20px;
  &__title{
    color: #161616;
    font-size: 16px;
    line-height: 25px;
    margin-right: 8px;
  }
  &__count{
    color: #161616;
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    margin-right: 10px;
  }
  &__btn{
    border-radius: 18px;
    background-color: #008cff;
    padding: 8px 18px 10px;
    color: #fff;
    font-size: 18px;
    text-decoration: none;
    &:hover{
      background-color: #026ac0;
    }
  }
}
.menu-user{
  display: flex;
  align-items: center;
  position: relative;
  &__name{
    color: #161616;
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    text-decoration: none;
    .svg-icon{
      margin-left: 10px;
    }
  }
}
.dropdown-menu{
  position: absolute;
  top: 63px;
  right: 0;
  width: 137px;
  box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  background-color: #ffffff;
  padding: 0;
  margin: 0;
  display: none;
  &.active{
    display: block;
  }
  &__li{
    display: block;
  }
  &__link{
    color: #161616;
    font-size: 16px;
    text-decoration: none;
    padding: 15px 25px;
    display: block;
    &:hover{
      background-color: #e7f1f8;
    }
  }
}

.header-nav-mobile{
  padding: 0;
  margin: 0;
  &__li{
    display: block;
  }
  &__link{
    display: none;
    color: #161616;
    font-size: 22px;
    font-weight: 700;
    line-height: 25px;
    text-decoration: none;
    &.router-link-active{
      display: block;
    }
  }
}
.back-page{
  flex-shrink: 0;
  margin-right: 20px;
  color: #161616;
  width: 25px;
  .svg-icon{
    display: block;
    width: 20px;
    height: 20px;
  }
}
.gamb{
  flex-shrink: 0;
  margin-right: 20px;
  color: #161616;
  width: 25px;
  .svg-icon{
    display: block;
    width: 25px;
    height: 25px;
  }
}
.gamb-close{
  position: absolute;
  top: 23px;
  right: 23px;
  width: 20px;
  height: 20px;
  color: #161616;
  .svg-icon{
    display: block;
    width: 100%;
    height: 100%;
  }
}
.gamb-hidden{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  background-color: #f4f5f6;
  padding: 15px;
  box-sizing: border-box;
  z-index: 10;
  min-height: 100vh;
  .user{
    flex-direction: column;
    align-items: flex-start;
    &__ava{
      margin-right: 10px;
    }
    &__top{
      display: flex;
      align-items: center;
      margin-bottom: 35px;
    }
    .menu-user__name{
      max-width: 150px;
    }
  }
  .cash-user{
    width: 100%;
    justify-content: space-between;
    margin-right: 0;
  }
}
.nav-mobile{
  background: #fff;
  margin: 0;
  padding: 20px;
  width: 100%;
  margin: 30px -20px;
  &__li{
    display: block;
    &:last-child{
      .nav-mobile__link{
        margin-bottom: 0;
      }
    }
  }
  &__link{
    color: #161616;
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    text-decoration: none;
    margin-bottom: 20px;
    display: block;
    &.router-link-active{
      font-weight: 700;
    }
  }
}
.mobile-menu-user{
  margin: 0;
  padding: 0;
  &__li{
    display: block;
  }
  &__link{
    color: #161616;
    font-size: 16px;
    font-weight: 400;
    line-height: 25px;
    text-decoration: none;
    margin-bottom: 20px;
    display: block;
    &.router-link-active{
      font-weight: 700;
    }
  }
}
@media (max-width: 991px)  {
  .header{
    padding: 23px 20px;
  }
}
</style>
